import { RefObject, useCallback, useEffect } from 'react';

export const useRightClick = <T extends HTMLElement>(
    ref: RefObject<T>,
    onRightClick: (event?: MouseEvent) => void
): void => {
    const handleClick = useCallback(
        (e: MouseEvent) => {
            const { current } = ref;

            if (current && current.contains(e.target as Node)) {
                onRightClick(e);
            }
        },
        [onRightClick, ref]
    );

    useEffect(() => {
        document.addEventListener<'contextmenu'>('contextmenu', handleClick);

        return () => {
            document.removeEventListener<'contextmenu'>('contextmenu', handleClick);
        };
    }, [handleClick]);
};
